import { writable } from 'svelte/store';

export type NavigationStore = {
	back?: string;
	close?: string;
	title?: string;
	previousPages: string[];
	progress?: number;
};

export const createNavigationStore = (nav: NavigationStore) => {
	return writable(nav);
};

export type NavigationStoreType = ReturnType<typeof createNavigationStore>;
